import { types } from 'mobx-state-tree';

import OptionalIdentifier from '../types/OptionalIdentifier';
import Contact from './Contact';
import Mortgage from './Mortgage';
import Property from './Property';
import Provider from './Provider';


// Extending Mortgage model to add an identifier because
// in arrays, items without an identifier are never reconciled.
const CalculatorMortgage = Mortgage.props({
    id: OptionalIdentifier,
});

const RefinanceSpecificValues = types.model('RefinanceSpecificValues', {
    knownPenaltyFee: types.maybe(types.number),
});

const PaymentSpecificValues = types.model('PaymentSpecificValues', {
    lawyerFees: types.maybe(types.number),
    titleInsuranceCost: types.maybe(types.number),
    homeInspectionCost: types.maybe(types.number),
    appraisalFees: types.maybe(types.number),
    estoppelFees: types.maybe(types.number),
    mortgages: types.maybe(types.array(CalculatorMortgage)),
});

const Calculators = types.model('MortgageCalculators', {
    id: OptionalIdentifier,
    mortgage: types.maybe(CalculatorMortgage),
    contacts: types.maybe(types.array(Contact)),
    property: types.maybe(Property),
    provider: types.maybe(Provider),
    firstTimeHomeBuyer: types.maybe(types.boolean),
    refinance: types.maybe(RefinanceSpecificValues),
    payment: types.maybe(PaymentSpecificValues),
});

export default Calculators;
